import { serverAddr } from "../networkConfig";
// import axios from "axios";

export default {
	getAllStoreData() {
		return serverAddr.get("outlet/?get_all=true");
	},
	getSingleStoreData(paramss) {
		return serverAddr.post("/sales/rt_dashboad_overview/", paramss);
	},
	getSingleStoreAggregateData(params) {
		return serverAddr.post("/sales/rt_dashboad_aggregate/", params);
	},
	getBusinessDayPart(params) {
		return serverAddr.post(`/read/business-days-day-part/`, params);
	},
	getNotificationType() {
		return serverAddr.get("/users/set_notifications/get_notifications_type/");
	},
	deleteNotification(params) {
		return serverAddr.post("/users/set_notifications/delete_set_notification/", params);
	},
	getLocation() {
		return serverAddr.get("/outlet/location_new/");
	},
	getNotificationData(params) {
		// return serverAddr.get("/users/set_notifications/get_set_notifications/");
		return serverAddr.post("/users/set_notifications/get_notifications_by_store/", params);
	},
	addSalesTarget(param) {
		return serverAddr.post("/sales/add/update/sales_target/", param);
	},
	addNotificationType(params) {
		return serverAddr.post(
			`/users/set_notifications/add_update_set_notifications/`,
			params
		);
	},
	getUsersForNotification(params) {
		return serverAddr.post(`/users/set_notifications/users_for_notifications/`,params);
	},
	addTargets(params) {
		return serverAddr.post(`/sales/add/update/sales_target/`, params);
	},
	getTargets(params) {
		return serverAddr.post(`/sales/get_sales_target/`, params);
	},
	getRecommendationNotification(store_id) {
		return serverAddr.get(`/users/set_notifications/get_push_notifications/?store_id=${store_id}`);
	},
	getPromotionPrediction(params) {
		return serverAddr.post(`/promotion/get_promotion_prediction/`, params);
	}
};
